<template>
  <div class="Layout">
    <!--左侧导航区域-->

    <el-scrollbar>
      <Menu class="left" :iscollapse="iscollapse"></Menu>
    </el-scrollbar>
    <Content
      class="right"
      :class="{ rightActive: iscollapse }"
      @changCollapse="changCollapse"
      :iscollapse="iscollapse"
    ></Content>
    <!--右侧内容 路由出口-->
  </div>
</template>

<script>
import Menu from "./menu.vue";
import Content from "./content.vue";
export default {
  components: {
    Menu,
    Content,
  },
  data() {
    return {
      iscollapse: false,
      username: "",
      time: "",
    };
  },
  methods: {
    changCollapse() {
      this.iscollapse = !this.iscollapse;
    },
  },
  created() {
    //this.username = this.$route.query.username;
    //this.time = this.$route.query.time;
  },
};
</script>

<style lang='less' scoped>
.Layout {
  .left {
    position: fixed;
    top: 0;
    bottom: 0;
    background-color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    overflow-x: none;
  }
  @keyframes rtmove0 {
    0% {
      margin-left: 64px;
    }
    100% {
      margin-left: 200px;
    }
  }
  @keyframes rtmove1 {
    0% {
      margin-left: 200px;
    }
    100% {
      margin-left: 64px;
    }
  }
  .right {
    animation: rtmove0 0.1s;
    animation-fill-mode: forwards;
  }
  .rightActive {
    animation: rtmove1 0.5s;
    animation-fill-mode: forwards;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage_views/main.vue